import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_small_fallback_paywall~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_small_fallback_paywall__b'),
			},
		},
		'activity-female-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_small_fallback_paywall~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_small_fallback_paywall__b'),
			},
		},
		'activity-female-tai-chi-walking-v2-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_small_fallback_paywall~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_small_fallback_paywall__b'),
			},
		},
	},
	{
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_small_fallback_paywall~2
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_small_fallback_paywall__c'),
			},
		},
		'activity-female-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_small_fallback_paywall~2
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_small_fallback_paywall__c'),
			},
		},
		'activity-female-tai-chi-walking-v2-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_small_fallback_paywall~2
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_small_fallback_paywall__c'),
			},
		},
	},
]

export default config
